var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_3904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.11523 18.3458V23.1771C9.11523 23.5146 9.3319 23.8135 9.65273 23.9198C9.73294 23.9458 9.81523 23.9583 9.89648 23.9583C10.1402 23.9583 10.3757 23.8437 10.5257 23.6396L13.3517 19.7937L9.11523 18.3458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6719 0.144884C24.4323 -0.0249077 24.1178 -0.0478244 23.8573 0.088634L0.419838 12.3282C0.142755 12.473 -0.020787 12.7688 0.00212966 13.0803C0.026088 13.3928 0.23338 13.6595 0.528171 13.7605L7.0438 15.9876L20.9198 4.12301L10.1823 17.0595L21.1021 20.7918C21.1834 20.8188 21.2688 20.8334 21.3542 20.8334C21.4959 20.8334 21.6365 20.7949 21.7605 20.7199C21.9584 20.5991 22.0928 20.3959 22.1271 20.1678L24.9917 0.896967C25.0344 0.605301 24.9115 0.315717 24.6719 0.144884Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_3904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperplane);
export default __webpack_public_path__ + "static/media/paperplane.202cda0a1fdf9f8c79de7b6164476c5a.svg";
export { ForwardRef as ReactComponent };